import { observer } from 'mobx-react-lite';
import React from 'react';
import { colors } from '../../../../../../../../../colorVars';
import { useWebsocketStore } from '../../../../../../../../../stores/websocketStore/websocketProvider';
import ApplyRounding from '../../../../../../../../../utils/math/ApplyRounding';
import { HoverBox } from '../../../hoverBox/HoverBox';

export const UnderlyingPriceExitLine = observer(
  ({
    tradePlanId,
    underlyingPriceExits,
    size,
    scaleY,
    portalRef,
  }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
    const paused =
      tradePlan?.exitTactics['UNDERLYING_PRICE_EXIT']?.paused ?? null;
    return (
      <>
        {scaleY ? (
          <g strokeWidth={1}>
            <g stroke={colors.green}>
              {underlyingPriceExits.map(({ price, qtyPct }, index) => {
                const yPos = scaleY(price);
                return (
                  <g key={price}>
                    {paused ? (
                      <line
                        strokeDasharray={4}
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    ) : (
                      <line
                        style={{ opacity: index === 0 ? 1 : 0.3 }}
                        x1={0}
                        x2={size}
                        y1={yPos}
                        y2={yPos}
                      />
                    )}

                    <HoverBox
                      json={{
                        Category: 'Exit Tactic',
                        Type: 'Underlying Price',
                        Price: ApplyRounding(Number(price), 2),
                        'Pct. of Position': Number(qtyPct) * 100 + '%',
                      }}
                      topBoundary={yPos - 2}
                      bottomBoundary={yPos + 2}
                      leftBoundary={0}
                      rightBoundary={size}
                      portalRef={portalRef}
                      size={size}
                    />
                  </g>
                );
              })}
            </g>
          </g>
        ) : null}
      </>
    );
  }
);
